
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passport-control",
      function () {
        return require("private-next-pages/passport-control.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passport-control"])
      });
    }
  